import { format, parseISO } from "date-fns";
import { RawSession } from "../types/api/userSession";
import { Drill, RawDrill, RawRepetition, Repetition, Scenario } from "../types/models";
import { UserTransaction } from "../types/models/userTransaction";
import { EnhancedSession } from "../types/ui/userSession";
import { calculateDurationLabel } from "../utils/formatters";



export function toEnhancedSession(s: RawSession): EnhancedSession {
  const start = parseISO(s.start_time);
  const dateLabel = format(start, 'MMMM d, yyyy');
  const timeLabel = format(start, 'h:mm a');

  let durationLabel: string;
  if (!s.end_time) {
    durationLabel = 'Ongoing';
  } else if (s.end_time === '1969-12-31T23:59:59') {
    durationLabel = 'Terminated';
  } else {
    durationLabel = calculateDurationLabel(s.start_time, s.end_time);
  }

  const scenarios = s.total_transactions;

  return { id: s.id, dateLabel, timeLabel, durationLabel, scenarios };
}


export function toEnhancedSessions(raw: RawSession[]): EnhancedSession[] {
  return raw.map(toEnhancedSession);
}
export function toScenario(tx: UserTransaction): Scenario {
  return {
    id: String(tx.id),
    sessionId: tx.session_id != null ? String(tx.session_id) : '',
    name: tx.scenario_name,
    thumbnailUrl: undefined,
    drills: [],
  };
}

export function toDrill(d: RawDrill): Drill {
  return {
    id: String(d.id),
    scenarioId: String(d.scenario_id),
    name: d.name,
    repetitions: [],
  };
}

export function toRepetition(r: RawRepetition): Repetition {
  return {
    id: String(r.id),
    drillId: String(r.drill_id),
    timestamp: r.timestamp,
    metrics: r.metrics,
  };
}